import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './NotificationMoveButton.scss';

import Tooltip from '../../General/Tooltip';

const PRESET_REASON = 'Moving a notification takes the Notification Launch preset.';

// A disabled button never receives the hover, so the reason lives on the span around it.
const NotificationMoveButton = ({ move, enabled, onClick }) => {
  const reason = !enabled ? PRESET_REASON : move.locked ? move.lockedReason : null;
  const button = (
    <button
      type='button'
      className={cn('mode-segment', { locked: move.locked, quiet: move.quiet })}
      disabled={!!reason}
      title={reason || undefined}
      onClick={onClick}
    >
      {move.label}
    </button>
  );
  if (!reason) return button;
  return (
    <Tooltip outerClassName='mode-tip' message={reason} position='top' size='regular'>
      <span className='mode-hit'>{button}</span>
    </Tooltip>
  );
};

NotificationMoveButton.propTypes = {
  move: PropTypes.shape({
    mode: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    locked: PropTypes.bool,
    lockedReason: PropTypes.string,
    quiet: PropTypes.bool
  }).isRequired,
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default NotificationMoveButton;
